module.exports = __webpack_public_path__ + "img/manual5.a7b0a94a.png";